import http from "./configServices/httpService";
import { base_url } from "./configServices/config";

export const getOrdersCourierService = (onlyActive = true, page = 1, limit = 10) => {
  return http.get(`${base_url}/courier/orders?onlyActive=${onlyActive}&page=${page}&limit=${limit}`);
};